import { MandantSettings } from '../../util/types';



function load(url: string): string {
  try{
    return require(`${url}`);
  }
  catch(e){
    console.error(`Missing mandant icon: ${url}`);
    return null;
  }
}

export const mandantSettings: MandantSettings[] = [
  {
    mandant: 'tudo',
    institution: 'APP-OFZR6297G4QVO8B6',
    usesOrcid: true,
    loginEnabled: true,
    domains: ['tu-dortmund.de', 'tudo.test'],
    topOrga: 'Technische Universität Dortmund',
    icon: load('./tudo/icon.svg'),
    jsScripts: [],
  },
  {
    mandant: 'rub',
    institution: 'APP-OZVG6PSQT2L2OBUK',
    usesOrcid: true,
    loginEnabled: true,
    domains: ['ruhr-uni-bochum.de', 'rub.de', 'rub.test'],
    topOrga: 'Ruhr-Universität Bochum',
    icon: load('./rub/icon.svg'),
    jsScripts: [],
  },
  {
    mandant: 'hhu',
    institution: '',
    usesOrcid: false,
    loginEnabled: true,
    domains: ['hhu.de', 'uni-duesseldorf.de', 'hhu.test'],
    topOrga: 'Heinrich-Heine-Universität Düsseldorf',
    icon: load('./hhu/icon.svg'),
    jsScripts: [
      'var _mtm = window._mtm = window._mtm || [];\n' +
        "_mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});\n" +
        "var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n" +
        "g.async=true; g.src='https://piwik.ub.uni-duesseldorf.de/piwik/js/container_eudl0gSm.js'; s.parentNode.insertBefore(g,s);",
    ],
  },
  {
    mandant: 'uwh',
    institution: 'APP-R7XYRUP253K4348R',
    usesOrcid: true,
    loginEnabled: true,
    domains: ['uni-wh.de', 'uwh.test'],
    topOrga: 'Universität Witten/Herdecke',
    icon: load('./uwh/icon.svg'),
    jsScripts: [],
  },
  {
    mandant: 'ril',
    institution: '',
    usesOrcid: false,
    loginEnabled: false,
    domains: ['ruhr-innovation-lab.de'],
    topOrga: 'Ruhr Innovation Lab',
    icon: load('./ril/icon.png'),
    jsScripts: [],
    favicon: 'favicon-ril.png',
  },
];
